import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/my-downloads_/basic-business-accountancy")({
  beforeLoad: () => {
    throw redirect({ to: "/my-courses/basic-business-accountancy" });
  },
});
